import { Alert, Button, Form, Input } from "antd"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import apiClient from "../../Utils/apiClient"
import { useDispatch } from "react-redux"
import { setUser } from "../../Redux/Slices/UserSlice"
import AuthShell from "../../Layout/AuthShell"

const TwoFactorAuth = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")

  const onFinish = async (values) => {
    try {
      setLoading(true)
      setError("")
      const token = Array.isArray(values.token)
        ? values.token.join("")
        : String(values.token ?? "").replace(/\s+/g, "")
      const res = await apiClient(
        "auth/2fa/login",
        "POST",
        { token },
        { refresh: false }
      )

      if (res.success) {
        localStorage.setItem("user", JSON.stringify(res))
        dispatch(setUser(res.data?.user))
        navigate("/")
      } else {
        setError(res.message || "That code is incorrect or has expired. Try the latest code.")
      }
    } catch (err) {
      setError("Could not verify the code. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthShell
      title="Two-factor verification"
      subtitle="Open your authenticator app and enter the current 6-digit code."
      footer="Codes refresh every 30 seconds. Use the newest one if a previous attempt failed."
      steps={["Credentials", "Verify", "Console"]}
      activeStep={2}
      badge="Almost signed in"
    >
      <Form
        className="auth-form"
        layout="vertical"
        onFinish={onFinish}
        requiredMark={false}
      >
        {error ? (
          <Alert
            type="error"
            showIcon
            message={error}
            className="mb-3"
            closable
            onClose={() => setError("")}
          />
        ) : null}
        <Form.Item
          label="Authenticator code"
          name="token"
          rules={[
            { required: true, message: "Enter the 6-digit code" },
            { len: 6, message: "Enter all 6 digits" },
          ]}
        >
          <Input.OTP length={6} size="large" inputMode="numeric" />
        </Form.Item>
        <Form.Item className="mb-0">
          <Button
            className="auth-submit"
            type="primary"
            htmlType="submit"
            block
            size="large"
            loading={loading}
          >
            Verify and sign in
          </Button>
        </Form.Item>
        <Button type="link" block className="mt-2" onClick={() => navigate("/login")}>
          Back to sign-in
        </Button>
      </Form>
    </AuthShell>
  )
}

export default TwoFactorAuth
